import { VFlex } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VLayout,{attrs:{"wrap":"","align-center":"","purchase":""}},[_c(VFlex,{attrs:{"xs3":""}},[_c(VImg,{attrs:{"src":_vm.application.image || require('@/images/no-image.png'),"max-width":"50"}})],1),_c(VFlex,{attrs:{"xs9":"","pl-1":""}},[_c('b',[_vm._v(_vm._s(_vm.application.name))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }